module.exports = __webpack_public_path__ + "img/local_pin_selected.b3e5a75f.png";